import React, {Component} from "react"
import {withRouter} from "react-router-dom"
import {get} from "lodash"
import PropTypes from "prop-types"

import {Reward, Product} from "@irati/types"

import RewardWalletBalanceQuery, {RewardWalletBalanceData} from "@irati/wallet/apollo/query/RewardWallet"
import {FormattedCurrency, FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import {Hr} from "@irati/ui/src/Layout"
import history from "@irati/utils/history"
import id from "@irati/utils/id"
import {rewardTracking} from "@irati-tracking/reward"
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet"

import {buildProductOptions} from "../../utils"
import ImportantInfo from "./ImportantInfo"
import TermsAndConditions from "./TermsAndConditions"
import {AvailableBalance, StyledCaption, RewardOptions, Button} from "./styled"

interface Props extends InjectIntl {
  className?: string,
  onClickTermsAndConditions?: () => void,
  reward: Reward
}

interface State {
  options: any[],
  selectedOption: string | null,
  clickDenominationEventTracked: boolean
}

class Summary extends Component<Props, State> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  state: State = {
    options: [],
    selectedOption: null,
    clickDenominationEventTracked: false
  }

  componentDidMount() {
    const {intl, reward} = this.props
    const options = buildProductOptions(reward, intl)
    const selectedOption = options[0].value
    this.setState({options, selectedOption})
  }

  handleButtonClick = () => {
    const {selectedOption} = this.state
    const {reward} = this.props
    const products = get(reward, "products.results")
    const selectedProduct = products.find((product: Product) => product.uuid === selectedOption)
    rewardTracking.rewardsTabAddRewardStart(reward)
    history.push(
      {
        pathname: "/reward/create",
        state: {
          reward,
          product: selectedProduct
        }
      },
      this.context
    )
  }

  handleButtonClickWithTracking = () => {
    rewardWalletTracking.clickRewardWithCredit()
    this.handleButtonClick()
  }

  handleSelectChangeWithTracking = (value: string) => {
    rewardWalletTracking.updateDenominationDropdown()
    this.handleSelectChange(value)
  }

  handleSelectChange = (value: string) => {
    this.setState({selectedOption: value})
  }

  handleClickDenominationDropdown = () => {
    if (!this.state.clickDenominationEventTracked) {
      this.setState({clickDenominationEventTracked: true})
      rewardWalletTracking.clickDenominationDropdown()
    }
  }

  render() {
    const {reward, onClickTermsAndConditions} = this.props
    const {options, selectedOption} = this.state
    const idNamespace = id("reward-detail-summary", this.props)

    if (reward.isCredit) {
      return (
        <>
          <RewardWalletBalanceQuery>
            {({data}: RewardWalletBalanceData) => {
              const {availableBalance, currency} = data.rewardWallet
              return (
                <>
                  <StyledCaption flush>
                    <FormattedMessage id="reward.detail.credit.availableBalance.title" />
                  </StyledCaption>
                  <AvailableBalance>
                    <FormattedCurrency isCents={false} currency={currency} value={availableBalance} />
                  </AvailableBalance>
                  <StyledCaption>
                    <FormattedMessage id="reward.detail.credit.availableBalance.footer" />
                  </StyledCaption>
                </>
              )
            }}
          </RewardWalletBalanceQuery>
          <Hr small />

          <div onClick={this.handleClickDenominationDropdown}>
            <RewardOptions
              id={id("select", idNamespace)}
              label="reward.detail.select.label"
              name="product-id"
              options={options}
              onChange={this.handleSelectChangeWithTracking}
              isClearable={false}
              value={selectedOption} />
          </div>

          <Button primary large onClick={this.handleButtonClickWithTracking}>
            <FormattedMessage id="reward.detail.creditReward.label" />
          </Button>
        </>
      )
    }

    return (
      <>
        <ImportantInfo reward={reward} />
        <TermsAndConditions reward={reward} onClick={onClickTermsAndConditions} />
        <Hr small />

        <RewardOptions
          id={id("select", idNamespace)}
          label="reward.detail.select.label"
          name="product-id"
          options={options}
          onChange={this.handleSelectChange}
          isClearable={false}
          value={selectedOption} />
        <Button primary large onClick={this.handleButtonClick}>
          <FormattedMessage id="reward.detail.btnReward.label" />
        </Button>
      </>
    )
  }
}

export default withRouter(injectIntl(Summary))
